<div class="vd-comments">
    <ol class="vd-comments-list" aria-live="polite">
        <li class="vd-comment" *ngFor="let c of comments; trackBy: trackByComment">
            <span class="vd-comment-avatar" [style.background]="c._sender?.userColor">{{ c._sender?.shortName }}</span>
            <span class="vd-comment-body">
                <span class="vd-comment-name">{{ c._sender?.nickname }}</span>
                <span class="vd-comment-text">{{ c.message }}</span>
            </span>
        </li>
        <li class="vd-comments-empty" *ngIf="!comments.length">No comments yet. Be the first.</li>
    </ol>
    <form class="vd-comments-form" (submit)="submit($event)">
        <label class="vd-sr-only" for="vd-comment-box">Add a comment</label>
        <textarea id="vd-comment-box" #box rows="1" maxlength="500" placeholder="Add a comment…"
            (keydown.enter)="submit($event)"></textarea>
        <button type="submit" class="vd-btn vd-btn-accent">{{ signedIn ? 'Send' : 'Sign in' }}</button>
    </form>
</div>
